import {FlexRow, styled} from "@reside/ui";

export const Space = styled(FlexRow)`
  align-items: center;
  & > * ~ * {
    margin-left: ${({theme}) => theme.space[4]}px;
  }
`;
